import { useState } from 'react';
import Modal from 'react-modal';
import { useSelector } from 'react-redux';
import Button from './Button';

interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
  title?: string;
  subTitle?: string;
  successIcon: boolean;
  errorIcon?: boolean;
  button?: boolean;
  buttonText?: string;
}
const SuccessModel: React.FC<ModalProps> = ({
  isOpen = false,
  closeModal,
  title,
  subTitle,
  successIcon,
  errorIcon = false,
  button = true,
  buttonText = false,
}) => {
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );

  const { entries, assets } = contentfulData || {};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick={false}
      contentLabel="Profile Edit success PopUp"
      className="z-[9999] fixed p-0 w-[330px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 md:outline-none"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
    >
      <div className="flex flex-col justify-center items-center gap-[20px] px-[20px] py-[30px] rounded-lg bg-white overflow-auto relative">
        {successIcon && (
          <img
            src={assets?.device_recogonized_success_popup_icon}
            alt="successIcon"
            className="w-[60px] h-[60px]"
          />
        )}
        {errorIcon && (
          <span className="border-2 rounded-full p-[10px] border-primary-red">
            <img
              src={assets?.web_secure_message_error_icon}
              alt="errorIcon"
              className="w-[40px] h-[40px]"
            />
          </span>
        )}
        <h3
          className="text-[#1F1F1F] text-[22px] font-[650] leading-[28px] tracking-[0.077px] text-center"
          aria-label={title}
        >
          {title}
        </h3>
        <p
          className="text-[#1F1F1F] text-[16px] font-[400] leading-[20px] tracking-[-0.051px] text-center"
          aria-label={subTitle}
        >
          {subTitle}
        </p>

        {button && (
          <button
            aria-label={
              buttonText || entries?.rb_rewards_setting?.rewardsSetting?.ok
            }
            onClick={closeModal}
            className=" cursor-pointer min-h-[48px] w-full max-w-[250px] h-10 bg-[#DA291C] text-white hover:bg-[#b32218] font-medium py-3 px-5 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 border border-1 border-primary-red"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                closeModal();
              }
            }}
          >
            {buttonText || entries?.rb_rewards_setting?.rewardsSetting?.ok}
          </button>
        )}
      </div>
    </Modal>
  );
};

export default SuccessModel;
